import { LocalEvent } from "@/features/planner/api/planner";

interface LocalEventsProps {
    events: LocalEvent[];
}

export const LocalEvents = ({ events }: LocalEventsProps) => {
    if (!events || events.length === 0) return null;

    return (
        <div className="mx-5 p-10 bg-white">
            <h2 className="text-center text-[28px] font-bold text-[#187A85] mb-6 font-serif">
                Local Events
            </h2>

            <div className="flex flex-col gap-4">
                {events.map((event, index) => (
                    <div key={index} className="bg-[#FFF9F5] rounded-xl p-6">
                        <div className="text-[16px] font-bold text-[#222222] mb-1">
                            {event.name}
                        </div>
                        <div className="text-[14px] text-[#333333] mb-2 flex items-center gap-2">
                            {event.when && (
                                <span className="flex items-center gap-1">
                                    📅 {event.when}
                                </span>
                            )}
                            {event.when && event.where && <span>•</span>}
                            {event.where && (
                                <span className="flex items-center gap-1">
                                    📍 {event.where}
                                </span>
                            )}
                        </div>
                        {event.note && (
                            <p className="text-[14px] text-[#333333] mb-2 leading-relaxed">
                                {event.note}
                            </p>
                        )}
                        {event.url && (
                            <a
                                href={event.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[14px] text-[#333333] underline decoration-1 hover:text-[#187A85] flex items-center gap-1 w-fit"
                            >
                                🔗 More Info
                            </a>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
